import { type Control } from 'react-hook-form'
import { FormValues, JsonFormPropertyV2 } from './types'
import { useConditionalRuleFields } from './useConditionalRuleFields'

/**
 * Watches form values and evaluates `readOnlyWhen` rules across all fields.
 * Returns a Set of field IDs that should be treated as read-only.
 */
export function useReadOnlyFields(properties: JsonFormPropertyV2[], control: Control<FormValues>): Set<string> {
  return useConditionalRuleFields(properties, 'readOnlyWhen', control)
}
